import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { AdminWrapper } from '../TCEndorsement/styles'
import { BannerText, ButtonsWrapper, FormItemWrapper, FormWrapper, InfoWrapper, StepTopWrapper } from '../LogisticCalculator/styles'
import { Banner, Button, MultiSelect, Select, TOAST_TYPE, UploadButton } from '@base'
import { strings } from '@constants'
import { showLoader, showToast } from '@data/state/action'
import { getAllUsers, toolsReconciliationProcess } from '@data'
import { displayName } from '@utils'

const CustomFormWrapper = styled(FormWrapper)`
	flex-grow: 1;
`

const deriveFormState = () => {
	const state = {
		organisation_ids: {
			id: 'organisations',
			label: strings('organisations'),
			placeholder: strings('select', 'organisations'),
			value: [],
			displayKey: 'display_name',
			primaryKey: 'organisation_id',
			disabled: false,
			required: false,
		},
		bank_name: {
			id: 'bank-name',
			label: strings('bank', 'name'),
			placeholder: strings(['select', 'bank', 'name']),
			value: '',
			displayKey: 'label',
			primaryKey: 'key',
			disabled: false,
			required: false,
		},
	}

	return state
}

const bankNameList = [
	{ key: 'IDFC', label: 'IDFC First Bank' },
	{ key: 'ICICI', label: 'ICICI' },
	{ key: 'AXIS', label: 'AXIS' },
]

const ReconciliationProcess = () => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(deriveFormState())
	const [organisationList, setOrganisationList] = useState([])

	useEffect(() => {
		dispatch(showLoader(true))

		getAllUsers()
			.then((response) => {
				setOrganisationList(response?.map((item) => ({ ...item, display_name: displayName(item) })) ?? [])
			})
			.catch((error) => {
				console.log(error)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [])

	const updateState = (key) => (value) => {
		setFormState((state) => ({
			...state,
			[key]: {
				...state[key],
				value: value,
			},
		}))
	}

	const resetForm = () => {
		setFormState(deriveFormState())
	}

	const uploadLedgerSheet = (file) => {
		if (file === null) {
			return
		}
		let file_name = file?.name?.split('.')?.[0]
		let file_extension = file?.name?.split('.').at(-1)?.toLowerCase()
		dispatch(showLoader(true))
		const bankName = formState?.bank_name?.value?.key
		const orgNames = formState?.organisation_ids?.value?.reduce((_acc, item) => {
			_acc.push(item?.organisation_id)
			return _acc
		}, [])
		let _ids = orgNames.join(', ')
		toolsReconciliationProcess(bankName, _ids, file, file_name, file_extension)
			.then((response) => {
				dispatch(showToast(true, strings('msg_reconciliation_process_done'), { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((err) => {
				let error_msg = err?.response?.data?.message ?? strings('msg_reconciliation_process_not_done')
				dispatch(showToast(true, error_msg, { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	const isDisabled = useMemo(() => {
		if (formState?.bank_name?.value === '') {
			return true
		}
		return false
	}, [formState?.bank_name?.value])
	return (
		<AdminWrapper>
			<CustomFormWrapper>
				<FormItemWrapper>
					<InfoWrapper>
						<Select
							label={formState?.bank_name?.label}
							id={formState?.bank_name?.id}
							placeholder={formState?.bank_name?.placeholder}
							value={formState?.bank_name?.value ?? {}}
							onChange={updateState('bank_name')}
							data={bankNameList}
							displayKey={formState?.bank_name?.displayKey}
							primaryKey={formState?.bank_name?.primaryKey}
							required={formState?.bank_name?.required}
							disabled={formState?.bank_name?.disabled}
						/>
					</InfoWrapper>
					<InfoWrapper>
						<MultiSelect
							label={formState?.organisation_ids?.label}
							id={formState?.organisation_ids?.id}
							placeholder={formState?.organisation_ids?.placeholder}
							value={formState?.organisation_ids?.value ?? []}
							onChange={updateState('organisation_ids')}
							data={organisationList}
							displayKey={formState?.organisation_ids?.displayKey}
							primaryKey={formState?.organisation_ids?.primaryKey}
							required={formState?.organisation_ids?.required}
							disabled={formState?.organisation_ids?.disabled}
							multiple
							showAllOptions
							hideSelectAll
						/>
					</InfoWrapper>

					<ButtonsWrapper>
						<Button type='primary' variant='destructive' small onClick={resetForm}>
							{strings('reset')}
						</Button>

						<UploadButton
							accept='excel'
							label={strings(['upload', 'ledger', 'sheet'])}
							disabled={isDisabled}
							small
							uppercase
							onChange={uploadLedgerSheet}
						/>
					</ButtonsWrapper>
					<StepTopWrapper>
						<Banner
							extendInMobile
							text={
								<BannerText>
									<span>
										* {strings('column_d_idfc_narrative')} <br />* {strings('column_g_icici_transaction_remarks')} <br />*{' '}
										{strings('column_d_axis_particulars')}
									</span>
								</BannerText>
							}
						/>
					</StepTopWrapper>
				</FormItemWrapper>
			</CustomFormWrapper>
		</AdminWrapper>
	)
}

export default ReconciliationProcess
